import React, { useState } from 'react';
import './ManagerEnquiry.css';

const ManagerEnquiry = () => {
  // Initial enquiries data for manager view
  const [enquiries, setEnquiries] = useState([
    {
      id: 1,
      enquiryNo: 'ENQ-X1Y2Z',
      client: 'Acme Industries',
      requirements: 'Looking for industrial automation solutions - 500 units of SKU-204, custom branding',
      estimatedBudget: '₹8,50,000',
      quote: '₹9,50,000',
      timeline: '6 weeks',
      status: 'Pending Approval',
      enquiryDate: '2024-12-01',
      assignedTo: 'Priya (Exec)',
      sourceLeadName: 'Rohit Sharma',
      submittedBy: 'Priya (Exec)',
      submittedDate: '2024-12-03',
      managerComments: null,
      rejectionReason: null,
      revisionComments: null,
      quoteDetails: {
        proposedQuote: '₹9,50,000',
        validUntil: '2025-01-15',
        message: 'Quote accepted by client',
        preparedDate: '2024-12-02',
        submittedDate: '2024-12-03',
        version: 2
      },
      quoteVersions: [
        {
          version: 1,
          proposedQuote: '₹8,50,000',
          validUntil: '2024-12-30',
          message: 'Initial quote',
          preparedDate: '2024-12-01',
          submittedDate: '2024-12-01',
          status: 'Quote Submitted'
        },
        {
          version: 2,
          proposedQuote: '₹9,50,000',
          validUntil: '2025-01-15',
          message: 'Revised quote',
          preparedDate: '2024-12-02',
          submittedDate: '2024-12-03',
          status: 'Pending Approval'
        }
      ]
    },
    {
      id: 2,
      enquiryNo: 'ENQ-M3N4O',
      client: 'Acme Industries',
      requirements: 'Service contract renewal for existing automation setup',
      estimatedBudget: '₹2,50,000',
      quote: '₹2,75,000',
      timeline: '2 weeks',
      status: 'Approved',
      enquiryDate: '2024-12-05',
      assignedTo: 'Karan (Exec)',
      sourceLeadName: 'Rohit Sharma',
      submittedBy: 'Karan (Exec)',
      submittedDate: '2024-12-05',
      managerComments: 'Quote approved by manager. Proceed with client.',
      rejectionReason: null,
      revisionComments: null,
      approvedDate: '2024-12-06',
      quoteDetails: {
        proposedQuote: '₹2,75,000',
        validUntil: '2024-12-30',
        message: 'Awaiting client response',
        preparedDate: '2024-12-05',
        submittedDate: '2024-12-05',
        version: 1
      },
      quoteVersions: [{
        version: 1,
        proposedQuote: '₹2,75,000',
        validUntil: '2024-12-30',
        message: 'Awaiting client response',
        preparedDate: '2024-12-05',
        submittedDate: '2024-12-05',
        status: 'Approved'
      }]
    },
    {
      id: 3,
      enquiryNo: 'ENQ-P9Q3R',
      client: 'Nimbus Tech',
      requirements: 'Cloud infrastructure setup and migration services',
      estimatedBudget: '₹15,00,000',
      quote: '₹16,50,000',
      timeline: '8 weeks',
      status: 'Approved',
      enquiryDate: '2024-12-10',
      assignedTo: 'Priya (Exec)',
      sourceLeadName: 'Anita Desai',
      submittedBy: 'Priya (Exec)',
      submittedDate: '2024-12-10',
      managerComments: 'Approved with recommendation',
      rejectionReason: null,
      revisionComments: null,
      approvedDate: '2024-12-11',
      quoteDetails: {
        proposedQuote: '₹16,50,000',
        validUntil: '2025-02-10',
        message: 'Contract signed - awaiting processing',
        preparedDate: '2024-12-10',
        submittedDate: '2024-12-10',
        version: 1
      },
      quoteVersions: [{
        version: 1,
        proposedQuote: '₹16,50,000',
        validUntil: '2025-02-10',
        message: 'Contract signed - awaiting processing',
        preparedDate: '2024-12-10',
        submittedDate: '2024-12-10',
        status: 'Approved'
      }]
    },
    {
      id: 4,
      enquiryNo: 'ENQ-R7S8T',
      client: 'Orbit Logistics',
      requirements: 'Fleet management software with real-time tracking',
      estimatedBudget: '₹12,00,000',
      quote: '₹13,20,000',
      timeline: '10 weeks',
      status: 'Rejected',
      enquiryDate: '2024-12-15',
      assignedTo: 'Karan (Exec)',
      sourceLeadName: 'Vikram Mehta',
      submittedBy: 'Karan (Exec)',
      submittedDate: '2024-12-18',
      managerComments: 'Quote too high compared to market standards',
      rejectionReason: 'Budget mismatch - client expectation is ₹10L max',
      revisionComments: null,
      rejectedDate: '2024-12-19',
      quoteDetails: {
        proposedQuote: '₹13,20,000',
        validUntil: '2025-01-20',
        message: 'Quote ready for client review',
        preparedDate: '2024-12-18',
        submittedDate: '2024-12-18',
        version: 1
      },
      quoteVersions: [{
        version: 1,
        proposedQuote: '₹13,20,000',
        validUntil: '2025-01-20',
        message: 'Quote ready for client review',
        preparedDate: '2024-12-18',
        submittedDate: '2024-12-18',
        status: 'Rejected'
      }]
    },
    {
      id: 5,
      enquiryNo: 'ENQ-U5V6W',
      client: 'BluePeak Foods',
      requirements: 'Cold storage monitoring and supply chain optimization',
      estimatedBudget: '₹6,00,000',
      quote: '₹6,50,000',
      timeline: '4 weeks',
      status: 'Revision Required',
      enquiryDate: '2024-12-20',
      assignedTo: 'Aarav (Admin)',
      sourceLeadName: 'Sara Khan',
      submittedBy: 'Aarav (Admin)',
      submittedDate: '2024-12-20',
      managerComments: 'Please revise pricing and add warranty details',
      rejectionReason: null,
      revisionComments: 'Reduce price by 10% and include 2 years AMC',
      quoteDetails: {
        proposedQuote: '₹6,50,000',
        validUntil: '2025-01-25',
        message: 'Quote submitted for approval',
        preparedDate: '2024-12-20',
        submittedDate: '2024-12-20',
        version: 1
      },
      quoteVersions: [{
        version: 1,
        proposedQuote: '₹6,50,000',
        validUntil: '2025-01-25',
        message: 'Quote submitted for approval',
        preparedDate: '2024-12-20',
        submittedDate: '2024-12-20',
        status: 'Revision Required'
      }]
    },
    {
      id: 6,
      enquiryNo: 'ENQ-W9X0Y',
      client: 'Starlight Corp',
      requirements: 'ERP implementation and customization',
      estimatedBudget: '₹25,00,000',
      quote: '₹28,00,000',
      timeline: '12 weeks',
      status: 'Pending Approval',
      enquiryDate: '2024-12-22',
      assignedTo: 'Priya (Exec)',
      sourceLeadName: 'Rajesh Kumar',
      submittedBy: 'Priya (Exec)',
      submittedDate: '2024-12-22',
      managerComments: null,
      rejectionReason: null,
      revisionComments: null,
      quoteDetails: {
        proposedQuote: '₹28,00,000',
        validUntil: '2025-02-28',
        message: 'Complete ERP solution with training',
        preparedDate: '2024-12-22',
        submittedDate: '2024-12-22',
        version: 1
      },
      quoteVersions: [{
        version: 1,
        proposedQuote: '₹28,00,000',
        validUntil: '2025-02-28',
        message: 'Complete ERP solution with training',
        preparedDate: '2024-12-22',
        submittedDate: '2024-12-22',
        status: 'Pending Approval'
      }]
    }
  ]);

  // Modal states
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [isApproveModalOpen, setIsApproveModalOpen] = useState(false);
  const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);
  const [isRevisionModalOpen, setIsRevisionModalOpen] = useState(false);
  const [isDocPreviewOpen, setIsDocPreviewOpen] = useState(false);
  const [selectedEnquiry, setSelectedEnquiry] = useState(null);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [selectedDocumentType, setSelectedDocumentType] = useState(null);
  
  // Form states
  const [approveComment, setApproveComment] = useState('');
  const [rejectReason, setRejectReason] = useState('');
  const [revisionComment, setRevisionComment] = useState('');

  // Get status badge class
  const getStatusClass = (status) => {
    switch (status) {
      case 'Pending Approval': return 'status-pending-approval';
      case 'Approved': return 'status-approved';
      case 'Rejected': return 'status-rejected';
      case 'Revision Required': return 'status-revision';
      default: return 'status-pending';
    }
  };

  // Get status display text
  const getStatusText = (status) => {
    switch (status) {
      case 'Pending Approval': return '⏳ Pending Approval';
      case 'Approved': return '✓ Approved';
      case 'Rejected': return '✗ Rejected';
      case 'Revision Required': return '🔄 Revision Required';
      default: return status;
    }
  };

  // View enquiry details
  const handleViewEnquiry = (enquiry) => {
    setSelectedEnquiry(enquiry);
    setIsViewModalOpen(true);
  };

  // Open approve modal
  const handleOpenApprove = (enquiry) => {
    setSelectedEnquiry(enquiry);
    setApproveComment('');
    setIsApproveModalOpen(true);
  };

  // Open reject modal
  const handleOpenReject = (enquiry) => {
    setSelectedEnquiry(enquiry);
    setRejectReason('');
    setIsRejectModalOpen(true);
  };

  // Open revision modal
  const handleOpenRevision = (enquiry) => {
    setSelectedEnquiry(enquiry);
    setRevisionComment('');
    setIsRevisionModalOpen(true);
  };

  // Approve enquiry
  const handleApprove = () => {
    const updatedEnquiries = enquiries.map(enq =>
      enq.id === selectedEnquiry.id
        ? {
            ...enq,
            status: 'Approved',
            managerComments: approveComment || 'Approved by manager',
            approvedDate: new Date().toLocaleDateString(),
            quoteDetails: {
              ...enq.quoteDetails,
              status: 'Approved'
            },
            quoteVersions: enq.quoteVersions.map(ver =>
              ver.version === enq.quoteDetails.version
                ? { ...ver, status: 'Approved' }
                : ver
            )
          }
        : enq
    );
    setEnquiries(updatedEnquiries);
    alert(`✓ Enquiry ${selectedEnquiry.enquiryNo} has been APPROVED!`);
    setIsApproveModalOpen(false);
    setSelectedEnquiry(null);
  };

  // Reject enquiry
  const handleReject = () => {
    if (!rejectReason.trim()) {
      alert('Please provide a reason for rejection');
      return;
    }
    const updatedEnquiries = enquiries.map(enq =>
      enq.id === selectedEnquiry.id
        ? {
            ...enq,
            status: 'Rejected',
            rejectionReason: rejectReason,
            managerComments: rejectReason,
            rejectedDate: new Date().toLocaleDateString(),
            quoteDetails: {
              ...enq.quoteDetails,
              status: 'Rejected'
            },
            quoteVersions: enq.quoteVersions.map(ver =>
              ver.version === enq.quoteDetails.version
                ? { ...ver, status: 'Rejected' }
                : ver
            )
          }
        : enq
    );
    setEnquiries(updatedEnquiries);
    alert(`✗ Enquiry ${selectedEnquiry.enquiryNo} has been REJECTED!`);
    setIsRejectModalOpen(false);
    setSelectedEnquiry(null);
    setRejectReason('');
  };

  // Request revision
  const handleRevision = () => {
    if (!revisionComment.trim()) {
      alert('Please provide revision comments for the sales executive');
      return;
    }
    const updatedEnquiries = enquiries.map(enq =>
      enq.id === selectedEnquiry.id
        ? {
            ...enq,
            status: 'Revision Required',
            revisionComments: revisionComment,
            managerComments: revisionComment,
            revisedDate: new Date().toLocaleDateString(),
            quoteDetails: {
              ...enq.quoteDetails,
              status: 'Revision Required'
            },
            quoteVersions: enq.quoteVersions.map(ver =>
              ver.version === enq.quoteDetails.version
                ? { ...ver, status: 'Revision Required' }
                : ver
            )
          }
        : enq
    );
    setEnquiries(updatedEnquiries);
    alert(`🔄 Revision requested for ${selectedEnquiry.enquiryNo}. Comments sent to sales executive.`);
    setIsRevisionModalOpen(false);
    setSelectedEnquiry(null);
    setRevisionComment('');
  };

  // View document
  const handleViewDocument = (docUrl, doc, docType) => {
    if (docUrl) {
      setSelectedDocument(docUrl);
      setSelectedDocumentType(docType);
      setIsDocPreviewOpen(true);
    } else {
      alert('No document available for this version');
    }
  };

  // Download document
  const downloadDocument = () => {
    if (selectedDocument) {
      const a = document.createElement('a');
      a.href = selectedDocument;
      a.download = '';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } else {
      alert('Document file not available for download');
    }
  };

  // Get file type for preview
  const getFileType = (url, mimeType) => {
    if (mimeType) {
      if (mimeType.startsWith('image/')) return 'image';
      if (mimeType === 'application/pdf') return 'pdf';
    }
    if (url) {
      const ext = url.split('.').pop().toLowerCase();
      if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext)) return 'image';
      if (['pdf'].includes(ext)) return 'pdf';
    }
    return 'link';
  };

  // Count statistics
  const totalEnquiries = enquiries.length;
  const pendingApprovalCount = enquiries.filter(e => e.status === 'Pending Approval').length;
  const approvedCount = enquiries.filter(e => e.status === 'Approved').length;
  const rejectedCount = enquiries.filter(e => e.status === 'Rejected').length;
  const revisionCount = enquiries.filter(e => e.status === 'Revision Required').length;

  return (
    <div className="manager-enq-container">
      <div className="manager-enq-wrapper">
        {/* Header Section */}
        <div className="manager-enq-header">
          <div className="manager-enq-header-top">
            <div className="manager-enq-header-left">
              <h1 className="manager-enq-title">Manager Enquiries</h1>
              <span className="manager-enq-badge">Quote Approval Panel</span>
            </div>
          </div>
          <p className="manager-enq-description">
            Review and manage all quote submissions from sales team. Approve, reject, or request revisions.
          </p>
        </div>

        {/* Statistics Cards */}
        <div className="manager-enq-stats">
          <div className="manager-enq-stat-card">
            <div className="manager-enq-stat-label">TOTAL ENQUIRIES</div>
            <div className="manager-enq-stat-value">{totalEnquiries}</div>
          </div>
          <div className="manager-enq-stat-card">
            <div className="manager-enq-stat-label">PENDING APPROVAL</div>
            <div className="manager-enq-stat-value" style={{ color: '#f59e0b' }}>{pendingApprovalCount}</div>
          </div>
          <div className="manager-enq-stat-card">
            <div className="manager-enq-stat-label">APPROVED</div>
            <div className="manager-enq-stat-value" style={{ color: '#1e7b48' }}>{approvedCount}</div>
          </div>
          <div className="manager-enq-stat-card">
            <div className="manager-enq-stat-label">REJECTED</div>
            <div className="manager-enq-stat-value" style={{ color: '#c2412c' }}>{rejectedCount}</div>
          </div>
          <div className="manager-enq-stat-card">
            <div className="manager-enq-stat-label">REVISION REQUIRED</div>
            <div className="manager-enq-stat-value" style={{ color: '#6b21a5' }}>{revisionCount}</div>
          </div>
        </div>

        {/* Enquiries Table */}
        <div className="manager-enq-table-section">
          <div className="manager-enq-table-wrapper">
            <div className="manager-enq-table-container">
              <table className="manager-enq-table">
                <thead>
                  <tr>
                    <th>SR. NO.</th>
                    <th>ENQUIRY #</th>
                    <th>CLIENT</th>
                    <th>REQUIREMENTS</th>
                    <th>EST. BUDGET</th>
                    <th>QUOTE</th>
                    <th>SUBMITTED BY</th>
                    <th>SUBMITTED DATE</th>
                    <th>VERSION</th>
                    <th>STATUS</th>
                    <th>ACTION</th>
                  </tr>
                </thead>
                <tbody>
                  {enquiries.map((enquiry, index) => (
                    <tr key={enquiry.id}>
                      <td data-label="SR. NO.">{index + 1}</td>
                      <td data-label="ENQUIRY #" className="manager-enq-cell-enquiry-no">{enquiry.enquiryNo}</td>
                      <td data-label="CLIENT">{enquiry.client}</td>
                      <td data-label="REQUIREMENTS" className="manager-enq-cell-requirements">{enquiry.requirements}</td>
                      <td data-label="EST. BUDGET">{enquiry.estimatedBudget}</td>
                      <td data-label="QUOTE">{enquiry.quote}</td>
                      <td data-label="SUBMITTED BY">{enquiry.submittedBy}</td>
                      <td data-label="SUBMITTED DATE">{enquiry.submittedDate}</td>
                      <td data-label="VERSION">
                        <span className="manager-enq-version-badge">v{enquiry.quoteDetails?.version || 1}</span>
                      </td>
                      <td data-label="STATUS">
                        <span className={`manager-enq-status-badge ${getStatusClass(enquiry.status)}`}>
                          {getStatusText(enquiry.status)}
                        </span>
                      </td>
                      <td data-label="ACTION">
                        <div className="manager-enq-action-group">
                          <button className="manager-enq-view-btn" onClick={() => handleViewEnquiry(enquiry)}>
                            View
                          </button>
                          {enquiry.status === 'Pending Approval' && (
                            <>
                              <button className="manager-enq-approve-btn" onClick={() => handleOpenApprove(enquiry)}>
                                Approve
                              </button>
                              <button className="manager-enq-reject-btn" onClick={() => handleOpenReject(enquiry)}>
                                Reject
                              </button>
                              <button className="manager-enq-revision-btn" onClick={() => handleOpenRevision(enquiry)}>
                                Revision
                              </button>
                            </>
                          )}
                        </div>
                       </td>
                     </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* View Enquiry Modal */}
      {isViewModalOpen && selectedEnquiry && (
        <div className="manager-enq-modal-overlay" onClick={() => setIsViewModalOpen(false)}>
          <div className="manager-enq-modal manager-enq-view-modal" onClick={(e) => e.stopPropagation()}>
            <div className="manager-enq-modal-header">
              <h3>Enquiry Details - {selectedEnquiry.enquiryNo}</h3>
              <button className="manager-enq-modal-close" onClick={() => setIsViewModalOpen(false)}>×</button>
            </div>
            <div className="manager-enq-modal-body">
              {/* Enquiry Details */}
              <div className="manager-enq-enquiry-details">
                <div className="manager-enq-detail-grid">
                  <div><strong>Client:</strong> {selectedEnquiry.client}</div>
                  <div><strong>Enquiry Date:</strong> {selectedEnquiry.enquiryDate}</div>
                  <div><strong>Source Lead:</strong> {selectedEnquiry.sourceLeadName || 'Manual'}</div>
                  <div><strong>Assigned To:</strong> {selectedEnquiry.assignedTo}</div>
                  <div><strong>Submitted By:</strong> {selectedEnquiry.submittedBy}</div>
                  <div><strong>Submitted Date:</strong> {selectedEnquiry.submittedDate}</div>
                  <div><strong>Requirements:</strong> {selectedEnquiry.requirements}</div>
                  <div><strong>Estimated Budget:</strong> {selectedEnquiry.estimatedBudget}</div>
                  <div><strong>Timeline:</strong> {selectedEnquiry.timeline}</div>
                </div>
              </div>

              {/* Quote Details */}
              <div className="manager-enq-quote-details">
                <h4>Quote Information</h4>
                <div className="manager-enq-quote-detail-row">
                  <span className="manager-enq-quote-label">Proposed Quote:</span>
                  <span className="manager-enq-quote-value manager-enq-highlight">{selectedEnquiry.quote}</span>
                </div>
                <div className="manager-enq-quote-detail-row">
                  <span className="manager-enq-quote-label">Valid Until:</span>
                  <span className="manager-enq-quote-value">{selectedEnquiry.quoteDetails?.validUntil || 'Not specified'}</span>
                </div>
                <div className="manager-enq-quote-detail-row">
                  <span className="manager-enq-quote-label">Version:</span>
                  <span className="manager-enq-quote-value">v{selectedEnquiry.quoteDetails?.version || 1}</span>
                </div>
                <div className="manager-enq-quote-detail-row">
                  <span className="manager-enq-quote-label">Status:</span>
                  <span className={`manager-enq-status-badge ${getStatusClass(selectedEnquiry.status)}`}>
                    {getStatusText(selectedEnquiry.status)}
                  </span>
                </div>
                <div className="manager-enq-quote-detail-row manager-enq-quote-message">
                  <span className="manager-enq-quote-label">Message:</span>
                  <span className="manager-enq-quote-value">{selectedEnquiry.quoteDetails?.message || 'No message'}</span>
                </div>
              </div>

              {/* Manager Comments Section */}
              {(selectedEnquiry.managerComments || selectedEnquiry.rejectionReason || selectedEnquiry.revisionComments) && (
                <div className="manager-enq-manager-comments">
                  <h4>Manager's Decision</h4>
                  {selectedEnquiry.managerComments && (
                    <div className="manager-enq-comment-row">
                      <strong>Comments:</strong> {selectedEnquiry.managerComments}
                    </div>
                  )}
                  {selectedEnquiry.rejectionReason && (
                    <div className="manager-enq-comment-row manager-enq-rejection">
                      <strong>Rejection Reason:</strong> {selectedEnquiry.rejectionReason}
                    </div>
                  )}
                  {selectedEnquiry.revisionComments && (
                    <div className="manager-enq-comment-row manager-enq-revision">
                      <strong>Revision Required:</strong> {selectedEnquiry.revisionComments}
                    </div>
                  )}
                  {selectedEnquiry.approvedDate && (
                    <div className="manager-enq-comment-row">
                      <strong>Approved Date:</strong> {selectedEnquiry.approvedDate}
                    </div>
                  )}
                  {selectedEnquiry.rejectedDate && (
                    <div className="manager-enq-comment-row">
                      <strong>Rejected Date:</strong> {selectedEnquiry.rejectedDate}
                    </div>
                  )}
                </div>
              )}

              {/* Version History */}
              {selectedEnquiry.quoteVersions && selectedEnquiry.quoteVersions.length > 0 && (
                <div className="manager-enq-versions-history">
                  <h4>Quote Version History</h4>
                  <div className="manager-enq-versions-table">
                    <table className="manager-enq-mini-table">
                      <thead>
                        <tr>
                          <th>Version</th>
                          <th>Quote Amount</th>
                          <th>Prepared Date</th>
                          <th>Submitted Date</th>
                          <th>Status</th>
                          <th>Document</th>
                         </tr>
                      </thead>
                      <tbody>
                        {selectedEnquiry.quoteVersions.map(ver => (
                          <tr key={ver.version} className={ver.version === (selectedEnquiry.quoteDetails?.version || 1) ? 'manager-enq-current-version' : ''}>
                            <td>v{ver.version}</td>
                            <td>{ver.proposedQuote}</td>
                            <td>{ver.preparedDate}</td>
                            <td>{ver.submittedDate || '-'}</td>
                            <td>
                              <span className={`manager-enq-status-badge ${getStatusClass(ver.status)}`}>
                                {ver.status}
                              </span>
                            </td>
                            <td>
                              {ver.documentUrl ? (
                                <button
                                  className="manager-enq-view-doc-btn"
                                  onClick={() => handleViewDocument(ver.documentUrl, ver, ver.documentType)}
                                >
                                  📄 View
                                </button>
                              ) : (
                                <span className="manager-enq-no-doc">—</span>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
            <div className="manager-enq-modal-footer">
              <button className="manager-enq-cancel-button" onClick={() => setIsViewModalOpen(false)}>Close</button>
            </div>
          </div>
        </div>
      )}

      {/* Approve Modal */}
      {isApproveModalOpen && selectedEnquiry && (
        <div className="manager-enq-modal-overlay" onClick={() => setIsApproveModalOpen(false)}>
          <div className="manager-enq-modal" onClick={(e) => e.stopPropagation()}>
            <div className="manager-enq-modal-header">
              <h3>Approve Quote - {selectedEnquiry.enquiryNo}</h3>
              <button className="manager-enq-modal-close" onClick={() => setIsApproveModalOpen(false)}>×</button>
            </div>
            <div className="manager-enq-modal-body">
              <div className="manager-enq-enquiry-details">
                <div><strong>Client:</strong> {selectedEnquiry.client}</div>
                <div><strong>Quote Amount:</strong> {selectedEnquiry.quote}</div>
                <div><strong>Submitted By:</strong> {selectedEnquiry.submittedBy}</div>
              </div>
              <div className="manager-enq-form-group">
                <label>Comments (Optional)</label>
                <textarea
                  value={approveComment}
                  onChange={(e) => setApproveComment(e.target.value)}
                  rows="3"
                  placeholder="Add any comments or notes..."
                />
              </div>
            </div>
            <div className="manager-enq-modal-footer">
              <button className="manager-enq-cancel-button" onClick={() => setIsApproveModalOpen(false)}>Cancel</button>
              <button className="manager-enq-approve-btn manager-enq-submit-btn" onClick={handleApprove}>Confirm Approve</button>
            </div>
          </div>
        </div>
      )}

      {/* Reject Modal */}
      {isRejectModalOpen && selectedEnquiry && (
        <div className="manager-enq-modal-overlay" onClick={() => setIsRejectModalOpen(false)}>
          <div className="manager-enq-modal" onClick={(e) => e.stopPropagation()}>
            <div className="manager-enq-modal-header">
              <h3>Reject Quote - {selectedEnquiry.enquiryNo}</h3>
              <button className="manager-enq-modal-close" onClick={() => setIsRejectModalOpen(false)}>×</button>
            </div>
            <div className="manager-enq-modal-body">
              <div className="manager-enq-enquiry-details">
                <div><strong>Client:</strong> {selectedEnquiry.client}</div>
                <div><strong>Quote Amount:</strong> {selectedEnquiry.quote}</div>
                <div><strong>Submitted By:</strong> {selectedEnquiry.submittedBy}</div>
              </div>
              <div className="manager-enq-form-group">
                <label>Reason for Rejection <span className="manager-enq-required">*</span></label>
                <textarea
                  value={rejectReason}
                  onChange={(e) => setRejectReason(e.target.value)}
                  rows="3"
                  placeholder="Please provide a detailed reason for rejection..."
                  required
                />
              </div>
            </div>
            <div className="manager-enq-modal-footer">
              <button className="manager-enq-cancel-button" onClick={() => setIsRejectModalOpen(false)}>Cancel</button>
              <button className="manager-enq-reject-btn manager-enq-submit-btn" onClick={handleReject}>Confirm Reject</button>
            </div>
          </div>
        </div>
      )}

      {/* Revision Modal */}
      {isRevisionModalOpen && selectedEnquiry && (
        <div className="manager-enq-modal-overlay" onClick={() => setIsRevisionModalOpen(false)}>
          <div className="manager-enq-modal" onClick={(e) => e.stopPropagation()}>
            <div className="manager-enq-modal-header">
              <h3>Request Revision - {selectedEnquiry.enquiryNo}</h3>
              <button className="manager-enq-modal-close" onClick={() => setIsRevisionModalOpen(false)}>×</button>
            </div>
            <div className="manager-enq-modal-body">
              <div className="manager-enq-enquiry-details">
                <div><strong>Client:</strong> {selectedEnquiry.client}</div>
                <div><strong>Current Quote:</strong> {selectedEnquiry.quote}</div>
                <div><strong>Submitted By:</strong> {selectedEnquiry.submittedBy}</div>
              </div>
              <div className="manager-enq-form-group">
                <label>Revision Comments <span className="manager-enq-required">*</span></label>
                <textarea
                  value={revisionComment}
                  onChange={(e) => setRevisionComment(e.target.value)}
                  rows="4"
                  placeholder="Provide detailed revision requirements (e.g., adjust pricing, add warranty, modify terms, etc.)..."
                  required
                />
              </div>
            </div>
            <div className="manager-enq-modal-footer">
              <button className="manager-enq-cancel-button" onClick={() => setIsRevisionModalOpen(false)}>Cancel</button>
              <button className="manager-enq-revision-btn manager-enq-submit-btn" onClick={handleRevision}>Send Revision Request</button>
            </div>
          </div>
        </div>
      )}

      {/* Document Preview Modal */}
      {isDocPreviewOpen && selectedDocument && (
        <div className="manager-enq-modal-overlay" onClick={() => setIsDocPreviewOpen(false)}>
          <div className="manager-enq-modal manager-enq-doc-preview-modal" onClick={(e) => e.stopPropagation()}>
            <div className="manager-enq-modal-header">
              <h3>Document Preview</h3>
              <button className="manager-enq-modal-close" onClick={() => setIsDocPreviewOpen(false)}>×</button>
            </div>
            <div className="manager-enq-modal-body manager-enq-doc-preview-body">
              {getFileType(selectedDocument, selectedDocumentType) === 'image' && (
                <img src={selectedDocument} alt="Document Preview" className="manager-enq-doc-img" />
              )}
              {getFileType(selectedDocument, selectedDocumentType) === 'pdf' && (
                <iframe
                  src={`${selectedDocument}#toolbar=0`}
                  title="PDF Preview"
                  className="manager-enq-doc-pdf"
                  frameBorder="0"
                />
              )}
              {getFileType(selectedDocument, selectedDocumentType) === 'link' && (
                <div className="manager-enq-doc-link">
                  <p>Preview not available for this file type.</p>
                  <button 
                    className="manager-enq-open-new-tab-btn"
                    onClick={() => window.open(selectedDocument, '_blank')}
                  >
                    Open in New Tab
                  </button>
                </div>
              )}
            </div>
            <div className="manager-enq-modal-footer">
              <button className="manager-enq-download-btn" onClick={downloadDocument}>⬇ Download</button>
              <button className="manager-enq-cancel-button" onClick={() => setIsDocPreviewOpen(false)}>Close</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ManagerEnquiry;